import { Product } from "../../../types/types";

export const generatePageName = (product: Product) => {
  const breadcrumbs = product.browsePageHierarchy.map((browsePage) =>
    browsePage.name.toLowerCase(),
  );
  breadcrumbs.shift();
  breadcrumbs.push(product.aliases.pimProductId);
  breadcrumbs.unshift("jl");
  return breadcrumbs.join(":");
};
